import { NetworkQualityStats } from "twilio-video";
import { Primitive } from "../../../types";

export function getTwilioNetworkQualityStats(
  stats: NetworkQualityStats,
): Record<string, Primitive> {
  return {
    // level
    level: stats.level,

    // audio recv
    "audio.recv.level": stats.audio?.recv,
    "audio.recv.latency.rtt": stats.audio?.recvStats?.latency?.rtt,
    "audio.recv.latency.jitter": stats.audio?.recvStats?.latency?.jitter,
    "audio.recv.bandwidth.actual": stats.audio?.recvStats?.bandwidth?.actual,
    "audio.recv.bandwidth.available":
      stats.audio?.recvStats?.bandwidth?.available,
    "audio.recv.fractionLost.level":
      stats.audio?.recvStats?.fractionLost?.level,
    "audio.recv.fractionLost.fractionLost":
      stats.audio?.recvStats?.fractionLost?.fractionLost,

    // audio send
    "audio.send.level": stats.audio?.send,
    "audio.send.latency.rtt": stats.audio?.sendStats?.latency?.rtt,
    "audio.send.latency.jitter": stats.audio?.sendStats?.latency?.jitter,
    "audio.send.bandwidth.actual": stats.audio?.sendStats?.bandwidth?.actual,
    "audio.send.bandwidth.available":
      stats.audio?.sendStats?.bandwidth?.available,
    "audio.send.fractionLost.level":
      stats.audio?.sendStats?.fractionLost?.level,
    "audio.send.fractionLost.fractionLost":
      stats.audio?.sendStats?.fractionLost?.fractionLost,

    // video recv
    "video.recv.level": stats.video?.recv,
    "video.recv.latency.rtt": stats.video?.recvStats?.latency?.rtt,
    "video.recv.latency.jitter": stats.video?.recvStats?.latency?.jitter,
    "video.recv.bandwidth.actual": stats.video?.recvStats?.bandwidth?.actual,
    "video.recv.bandwidth.available":
      stats.video?.recvStats?.bandwidth?.available,
    "video.recv.fractionLost.level":
      stats.video?.recvStats?.fractionLost?.level,
    "video.recv.fractionLost.fractionLost":
      stats.video?.recvStats?.fractionLost?.fractionLost,

    // video send
    "video.send.level": stats.video?.send,
    "video.send.latency.rtt": stats.video?.sendStats?.latency?.rtt,
    "video.send.latency.jitter": stats.video?.sendStats?.latency?.jitter,
    "video.send.bandwidth.actual": stats.video?.sendStats?.bandwidth?.actual,
    "video.send.bandwidth.available":
      stats.video?.sendStats?.bandwidth?.available,
    "video.send.fractionLost.level":
      stats.video?.sendStats?.fractionLost?.level,
    "video.send.fractionLost.fractionLost":
      stats.video?.sendStats?.fractionLost?.fractionLost,
  };
}
